// extracted by mini-css-extract-plugin
export default {"parent":"Banner2_parent__i1Fyp","banner_bottom":"Banner2_banner_bottom__iugsR"};